declare const Sentry: { captureException(error: unknown): void } | undefined;

export function reportError(message: string, error: unknown): void {
  console.error(message, error);
  if (typeof Sentry !== "undefined") {
    Sentry.captureException(error);
  }
}
